import { AxiosInstance, AxiosRequestConfig } from 'axios';

import helper from './helper';
import { AutocompleteRequestPayload } from './types';
const ENDPOINT = 'autocomplete/';

const autocomplete = (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  get: (payload: AutocompleteRequestPayload) =>
    instance.get<ApiResponse<EntityBase[]>>(
      ENDPOINT +
        payload.name +
        '/' +
        helper.toQueryString({ ...payload, name: undefined }),
      config
    ),
  getPaginated: (payload: AutocompleteRequestPayload) =>
    instance.get<ApiResponse<Paginated<'data', EntityBase>>>(
      ENDPOINT +
        payload.name +
        '/' +
        helper.toQueryString({ ...payload, name: undefined }),
      config
    ),
});
export default autocomplete;
